import React from 'react';
import { ShieldCheck, Lock, Zap, HeadphonesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://dog-calm.systeme.io/dogcalm';
export function OrderBumpSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <section className="py-14 px-5" style={{
    backgroundColor: '#0F3C3C'
  }} data-id="element-205">
      <div className="max-w-lg mx-auto text-center flex flex-col items-center" data-id="element-206">
        {/* Heading */}
        <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight mb-6" data-id="element-207">
          Su perro no necesita más fuerza, necesita que usted sepa{' '}
          <span className="text-accent" data-id="element-208">silenciar su estrés.</span>
        </h2>

        {/* Body */}
        <p className="text-white/70 text-[15px] md:text-base leading-relaxed mb-4" data-id="element-209">
          DOG-CALM™ no es un manual de entrenamiento tradicional. Es la clave
          biológica para que su perro deje de ver el mundo como una amenaza y
          empiece a verle a usted como su guía de calma.
        </p>
        <p className="text-white/70 text-[15px] md:text-base leading-relaxed mb-10" data-id="element-210">
          En menos de 10 minutos al día, transformará los tirones desesperados
          en una correa en sonrisa.
        </p>

        {/* CTA Button */}
        <button onClick={goToCheckout} className="w-full text-white font-extrabold text-lg py-5 rounded-full shadow-[0_0_25px_rgba(39,174,96,0.4)] flex flex-col items-center justify-center gap-1 transition-all active:scale-[0.98] border border-white/10" style={{
        backgroundColor: '#27AE60'
      }} data-id="element-211">
          <span data-id="element-212">SÍ, QUIERO PASEOS EN CALMA</span>
          <span className="text-sm font-medium opacity-80" data-id="element-213">
            Acceso inmediato por solo 9,95€ · Pago único
          </span>
        </button>

        {/* Trust Elements */}
        <div className="flex items-center justify-center gap-5 mt-6 flex-wrap" data-id="element-214">
          <span className="text-white/50 text-xs font-medium flex items-center gap-1.5" data-id="element-215">
            📥 Entrega en 10 seg
          </span>
          <span className="text-white/50 text-xs font-medium flex items-center gap-1.5" data-id="element-216">
            🔒 Pago Seguro SSL
          </span>
          <span className="text-white/50 text-xs font-medium flex items-center gap-1.5" data-id="element-217">
            ✅ Garantía de 14 días
          </span>
        </div>

        {/* Guarantee Trust Box */}
        <div className="mt-10 bg-[rgba(245,166,35,0.15)] border border-gold rounded-xl p-6 w-full shadow-lg relative overflow-hidden" data-id="element-218">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 blur-2xl rounded-full -z-10" data-id="element-219"></div>

          <div className="flex flex-col items-center text-center mb-5" data-id="element-220">
            <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 border border-gold/30 mb-4" data-id="element-221">
              <ShieldCheck className="w-6 h-6 text-gold" data-id="element-222" />
            </div>
            <h3 className="text-white font-extrabold text-xl mb-2" data-id="element-223">
              Garantía Profesional de Resultados: 14 Días.
            </h3>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-224">
              <strong className="text-white" data-id="element-225">
                Como especialistas en comportamiento animal, nuestro compromiso
                es su éxito.
              </strong>{' '}
              Si tras aplicar el Protocolo DOG-CALM durante 14 días no observa
              una mejora técnica en la reactividad de la correa, le reintegramos
              el 100% de su inversión de forma inmediata.
            </p>
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-white/5" data-id="element-226">
            <div className="flex items-center gap-1.5" data-id="element-227">
              <Lock className="w-3.5 h-3.5 text-white/40" data-id="element-228" />
              <span className="text-white/40 text-xs font-medium" data-id="element-229">
                Pago Encriptado SSL
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-230">
              <Zap className="w-3.5 h-3.5 text-white/40" data-id="element-231" />
              <span className="text-white/40 text-xs font-medium" data-id="element-232">
                Entrega en 10 seg
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-233">
              <HeadphonesIcon className="w-3.5 h-3.5 text-white/40" data-id="element-234" />
              <span className="text-white/40 text-xs font-medium" data-id="element-235">
                Soporte 24/7
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}